<template>
	<div>
		<hr>
		<div class="s-header-wrapper">
			<table class="s-header">
				<thead class='bold'>
					<tr>
						<td rowspan="3" class='medium_td'>Запрещение или ограничение законодательством</td>
						<td rowspan="2" colspan="2">СОМ</td>
						<td colspan="8">В том числе:</td>

						<td class='s-scroll' rowspan="3"></td>
					</tr>
					<tr>
						<td colspan="2">Сплошная санитарная рубка</td>
						<td colspan="2">Выборочная санитарная рубка</td>
						<td colspan="2">Уборка неликвидной древесины</td>
						<td colspan="2">Рубка аварийных деревьев</td>
					</tr>
					<tr>
						<td class='s-td small_td'>кол-во участков</td>
						<td class='s-td small_td'>Площадь, га</td>
						<td class='s-td small_td'>кол-во участков</td>
						<td class='s-td small_td'>Площадь, га</td>
						<td class='s-td small_td'>кол-во участков</td>
						<td class='s-td small_td'>Площадь, га</td>
						<td class='s-td small_td'>кол-во участков</td>
						<td class='s-td small_td'>Площадь, га</td>
						<td class='s-td small_td'>кол-во участков</td>
						<td class='s-td small_td'>шт</td>
					</tr>
				</thead>
			</table>
		</div>
		<div class="s-body-wrapper">
			<table class='s-body'>			
				<tbody>
					
					<tr v-for='(row, i) in rows'>
						<td class='medium_td'><span class="bold">{{row.npa}}</span></td>
						<td class='right s-td'>{{row.som_count}}</td>
						<td class='right s-td'>{{row.som_s_mzl}}</td>
						<td class='right s-td'>{{row.ssr_count}}</td>
						<td class='right s-td'>{{row.ssr_s_mzl}}</td>
						<td class='right s-td'>{{row.vsr_count}}</td>
						<td class='right s-td'>{{row.vsr_s_mzl}}</td>
						<td class='right s-td'>{{row.und_count}}</td>
						<td class='right s-td'>{{row.und_s_mzl}}</td>
						<td class='right s-td'>{{row.rad_count}}</td>
						<td class='right s-td'>{{row.rad_s_mzl}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_NPA_MZL_REPORT = 'get_npa_mzl_report.php'
	const REPORT_ID = 3

	export default {
		name: 'NpaMzl',
		data: function () {
			return {
				rows: []
			}
		},
		props: [
			'start',
			'end',
			'regions'
		],
		methods: {
			floatConvert (number) {
			    return +(parseFloat(number).toPrecision(12))
			},
			fillTable (start, end, regions) {
				let joined = 'null'
				if(regions.length)
					joined = '{' + regions.map(e => {return e.id}).join(',') + '}'

				fetch(DB + GET_NPA_MZL_REPORT + '?start=' + start + '&end=' + end + '&regions=' + joined)
				.then(res => res.json())
				.then(res => {
					let sum_som_count = 0
					let sum_som_s_mzl = 0
					let sum_ssr_count = 0
					let sum_ssr_s_mzl = 0
					let sum_vsr_count = 0
					let sum_vsr_s_mzl = 0
					let sum_und_count = 0
					let sum_und_s_mzl = 0
					let sum_rad_count = 0
					let sum_rad_s_mzl = 0

					for(let row of res)
					{
						sum_som_count += +row.som_count
						sum_som_s_mzl += +row.som_s_mzl
						sum_ssr_count += +row.ssr_count
						sum_ssr_s_mzl += +row.ssr_s_mzl
						sum_vsr_count += +row.vsr_count
						sum_vsr_s_mzl += +row.vsr_s_mzl
						sum_und_count += +row.und_count
						sum_und_s_mzl += +row.und_s_mzl
						sum_rad_count += +row.rad_count
						sum_rad_s_mzl += +row.rad_s_mzl
					}

					this.rows = res
					this.rows.push({
						npa: 'Итого',
						som_count: this.floatConvert(sum_som_count),
						som_s_mzl: this.floatConvert(sum_som_s_mzl),
						ssr_count: this.floatConvert(sum_ssr_count),
						ssr_s_mzl: this.floatConvert(sum_ssr_s_mzl),
						vsr_count: this.floatConvert(sum_vsr_count),
						vsr_s_mzl: this.floatConvert(sum_vsr_s_mzl),
						und_count: this.floatConvert(sum_und_count),
						und_s_mzl: this.floatConvert(sum_und_s_mzl),
						rad_count: this.floatConvert(sum_rad_count),
						rad_s_mzl: this.floatConvert(sum_rad_s_mzl),
					})
				})
				.then(() => {
					this.resizeTable()
				})
				.catch(err => console.log(err))
			},
			resizeTable() {
				const dispay_width = document.documentElement.clientWidth
				const dispay_height = document.documentElement.clientHeight
				let scroll_width = 17

				const ua = navigator.userAgent
				if (ua.search('OPR/') > 0) {
					scroll_width = 15
				}

				const table_width = document.querySelector('.s-header').clientWidth - scroll_width + 2
				const col_width = Math.floor((table_width) / 12)

				document.querySelectorAll('.s-td').forEach(td => {
					td.width = col_width
				})

				document.querySelectorAll('.medium_td').forEach(td => {
					td.width = 2 * col_width
				})
				document.querySelector('.s-scroll').width = scroll_width
			}
		},
		mounted () {
			this.fillTable(this.start, this.end, this.regions)

			EventBus.$on('npa-mzl-data', data => {
				this.fillTable(data.start, data.end, data.regions)
			})
			
			this.resizeTable()
			

			//document.querySelector('.s-header-wrapper').width = table_width
			//document.querySelector('.s-body-wrapper').width = table_width
			//document.querySelector('.s-body-wrapper').style.maxHeight = `${dispay_height - 340}px`

			// console.log(dispay_width, col_width, table_width)

			

			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))
			
		},
		created() {
			/*if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')*/
		},
		beforeDestroy() {
			EventBus.$off('npa-mzl-data')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
		padding-left: 2px;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.s-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		/*width: 1607px;*/
		/*width: 1630px;*/
	}

	div.s-body-wrapper {
		overflow-x: auto;
		overflow-y: auto;
		/*width: 1624px;*/
		/*width: 1640px;*/
		height: 65vh;
		border: 1px solid black;
		border-top: none;
	}

	table.s-header {
		border-bottom: 1px solid black;
		width: 100%;
	}

	table.s-body {
		/*table-layout: fixed;*/
		width: 100%;
	}
	
	td.s-td,  th.s-td {
		vertical-align: middle;  
		/*width: 192px;*/
		word-wrap: break-word;
	}

	td.s-td-small,  th.s-td-small {
		vertical-align: middle;  
		width: 52px;
		word-wrap: break-word;
	}

	td.small_td {
		/*width: 8%;*/
	}

	td.medium_td {
		/*width: 20%;*/
	}
</style>


// WEBPACK FOOTER //
// NpaMzl.vue?348848cc